import { getLastLocation } from '../../components/routing/LastLocationProvider'

export function hideLiveViewModal() { 
	const previousLocation=getLastLocation()
	if(previousLocation){
		window.history.back(1)
	}else{ //if have loaded app directly on NP (so no location history) set hash to empty
		window.location.hash=''
	}
}